<template>
  <div class="mySpinner" v-if="show">
    <div></div>
    <img :src="loading" alt="loader" />
  </div>
</template>
<script>
import loading from "../assets/img/Loading.gif";

export default {
  name: "Loading",
  data() {
    return {
      loading,
      show: this.$loading,
    };
  },
};
</script>
<style scoped>
.mySpinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  background-color: #f5ec4636;
  z-index: 50000;
  display: flex;
  justify-content: center;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.spinner > div {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 30%;
  left: 47%;
  right: 47%;
  width: 180px;
  height: 180px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #66d010;
  border-bottom-color: #66d010;
  border-width: 0.2em;
  animation: spinner 0.8s ease-in-out infinite;
}

.mySpinner > img {
  width: 200px;
  height: 200px;
  margin-top: 150px;
  /* position: absolute;
  top: 28%;
  left: 46%;
  width: 180px;
  height: 180px; */
}
</style>
